import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiFolder, FiFileText, FiChevronDown, FiChevronRight, FiUsers, FiBox, FiBriefcase, FiDollarSign } from 'react-icons/fi';

// A dynamic sidebar that adapts based on the current top-level module
export default function MainSidebar({ moduleName, menuItems }) {
  const location = useLocation();
  const [openSections, setOpenSections] = useState(
    menuItems.reduce((acc, item) => ({ ...acc, [item.id]: true }), {})
  );

  const isActive = (path) => {
    return location.pathname.startsWith(path) ? 'bg-[#b2ebf2] font-bold text-[#0000a0]' : 'text-gray-700 hover:bg-[#b2ebf2] hover:text-[#0000a0]';
  };

  const toggleSection = (section) => {
    setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  return (
    <div className="w-56 bg-[#e0f7fa] border-r border-teal-200 hidden md:flex flex-col flex-shrink-0">
      <div className="p-3 text-[14px] font-bold text-teal-900 border-b border-teal-200 bg-[#a6e4e7] uppercase tracking-wide">
        {moduleName}
      </div>
      
      <div className="flex-1 overflow-y-auto py-2">
        {menuItems.map((section, idx) => (
          <React.Fragment key={section.id}>
            <div className="mb-1">
              <div 
                className="flex items-center px-3 py-1.5 text-[13px] font-bold text-gray-800 cursor-pointer hover:bg-teal-100 transition-colors select-none"
                onClick={() => toggleSection(section.id)}
              >
                {openSections[section.id] ? <FiChevronDown className="mr-1 text-gray-500" /> : <FiChevronRight className="mr-1 text-gray-500" />}
                <FiFolder className="mr-1.5 text-yellow-500 fill-current" />
                {section.title}
              </div>
              
              {openSections[section.id] && (
                <ul className="text-[13px] pl-8 space-y-0.5 mt-0.5">
                  {section.links.map((link, lIdx) => (
                    <li key={lIdx}>
                      <Link to={link.path} className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive(link.path)}`}>
                        <link.icon className="mr-2 opacity-60 text-teal-800" /> {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {idx < menuItems.length - 1 && <div className="my-2 border-t border-teal-200 mx-2"></div>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}